<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-img
            src="../assets/iBowKINTAI-Horizontal-green.svg"
            max-width="100%"
            :height="logoHeight"
          />
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12 font-weight-bold">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>iBowKINTAIパスワード変更</v-toolbar-title>
            </v-toolbar>
            <v-form v-on:submit.prevent="passwordbtn" ref="form">
              <v-alert
                v-if="logedin"
                class="mt-2 mx-3"
                type="warning"
                v-html="message"
              />
              <v-card-text>
                <v-text-field
                  :autofocus="!ckdata"
                  label="事業所コード"
                  prepend-icon="mdi-office-building"
                  type="text"
                  v-model="office_code"
                  :rules="[(v) => !!v || '事業所コードは必須入力です。']"
                  v-if="!logedin"
                />
                <v-text-field
                  label="職員ID"
                  autocomplete="username"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="user_id"
                  :rules="[(v) => !!v || '職員IDは必須入力です。']"
                  v-if="!logedin"
                />
                <v-text-field
                  :autofocus="ckdata"
                  label="現在のパスワード"
                  prepend-icon="mdi-lock"
                  type="password"
                  autocomplete="current-password"
                  v-model="old_password"
                  :rules="[(v) => !!v || '現在のパスワードは必須入力です。']"
                />
                <v-text-field
                  label="新しいパスワード"
                  prepend-icon="mdi-lock"
                  type="password"
                  autocomplete="new-password"
                  v-model="new_password"
                  :rules="[password_rules]"
                />
                <v-text-field
                  label="新しいパスワードをもう一度入力してください"
                  prepend-icon="mdi-lock"
                  type="password"
                  autocomplete="new-password"
                  v-model="confirm_password"
                  :rules="[
                    () =>
                      confirm_password == new_password ||
                      '正しく入力してください',
                  ]"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="font-weight-bold"
                  v-if="!logedin"
                  color="cancel"
                  dark
                  :disabled="loading"
                  :loading="loading"
                  @click="$emit('endPassword')"
                  >戻る</v-btn
                >
                <v-btn
                  class="font-weight-bold"
                  color="primary"
                  dark
                  type="submit"
                  :disabled="loading"
                  :loading="loading"
                  >パスワード変更</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axiosMixin from "../mixins/axiosMixin";

export default {
  mixins: [axiosMixin],

  props: {
    logedin: Boolean,
    message: String,
  },

  data: () => ({
    ckdata: false,
    office_code: "",
    user_id: "",
    old_password: "",
    new_password: "",
    confirm_password: "",
  }),

  created: function () {
    this.ckdata = false;
    const office_code = this.getCookie("office_code");
    const userid = this.getCookie("userid");
    if (office_code) {
      this.office_code = office_code;
    }
    if (userid) {
      this.user_id = userid;
      this.ckdata = true;
    }
  },

  computed: {
    password_rules() {
      if (!this.new_password) {
        return "新しいパスワードは必須入力です。";
      }
      if (!/^[A-Za-z0-9#$%]*$/.test(this.new_password)) {
        return "半角英数の大文字、小文字、記号（#$%）でご記入ください。";
      }
      if (
        !/[#$%]/g.test(this.new_password) ||
        !/[a-z]/g.test(this.new_password) ||
        !/[A-Z]/g.test(this.new_password) ||
        !/[0-9]/g.test(this.new_password)
      ) {
        return "半角英数の大文字、小文字、記号（#$%）各１つ以上含めてご記入ください。";
      }
      if (this.new_password.length < 8) {
        return "8文字以上でご記入ください。";
      }
      if (this.new_password.length > 12) {
        return "12文字以下でご記入ください。";
      }
      if (this.old_password == this.new_password) {
        return "現在と同じパスワードです。";
      }
      return true;
    },
    logoHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 203;
        case "sm":
          return 137;
        case "md":
          return 99;
        case "lg":
          return 147;
        default:
          return 203;
      }
    },
  },

  methods: {
    passwordbtn() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!confirm("パスワードを変更します。よろしいですか？")) {
        return;
      }

      this.loading = true;

      this.postJsonCheck(
        window.base_url + "/auth/passwordchange",
        {
          office_code: Number(this.office_code),
          user_id: this.user_id,
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password,
        },
        () => {
          this.loading = false;
          this.setCookie("office_code", this.office_code, {
            "max-age": 864000,
            samesite: "strict",
          });
          this.setCookie("userid", this.user_id, {
            "max-age": 864000,
            samesite: "strict",
          });
          if (this.logedin) {
            if (window.token && window.reftoken) {
              this.setCookie("token", window.token, { samesite: "strict" });
              this.setCookie("reftoken", window.reftoken, {
                samesite: "strict",
              });
            }
          }
          this.$emit("endPassword");
        }
      );
    },
  },
};
</script>
